import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import type { FC } from "react";
import { DesignHuddleAssetPreviewModal } from "./design-huddle-asset-preview-modal";
import type { Asset } from "./server/digital-asset-service";
import { UploadedFileAssetPreviewModal } from "./uploaded-file-asset-preview-modal";

export const AssetPreviewModal: FC<{
  open: boolean;
  onClose: () => void;
  asset: Asset | null;
  onChange: () => void;
  onArchived?: () => void;
  onViewFileClick: (asset: Asset) => void;
  onFolderChange: () => void;
  folders_feature_flag?: boolean;
}> = ({
  asset,
  open,
  onClose,
  onChange,
  onArchived,
  onViewFileClick,
  onFolderChange,
  folders_feature_flag = false,
}) => {
  if (!asset) return null;

  return asset.content_type === "Uploaded File" ? (
    <UploadedFileAssetPreviewModal
      asset={asset}
      open={open}
      onClose={onClose}
      onChange={onChange}
      onArchived={onArchived}
      onViewFileClick={onViewFileClick}
      onFolderChange={onFolderChange}
      folders_feature_flag={folders_feature_flag}
    />
  ) : (
    <DesignHuddleAssetPreviewModal
      asset={asset}
      open={open}
      onClose={onClose}
      onChange={onChange}
      onFolderChange={onFolderChange}
      onArchived={onArchived}
      folders_feature_flag={folders_feature_flag}
    />
  );
};

export const ArchiveConfirmation: FC<{
  asset: Asset;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}> = ({ asset, open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{`Archive '${asset.title}'?`}</DialogTitle>
      <DialogContent>
        <Typography sx={{ pb: 3 }}>
          Archiving this asset will hide it from your Content Library. Embedded links to the asset
          will continue to work, but no one will be able to view it in the Content Library.
        </Typography>
        <Typography sx={{ pb: 3 }}>
          Alternatively, you can change or edit the asset to replace it.
        </Typography>
        <Typography>
          If you want to permanently delete the asset, contact support@changeengine.com.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} data-analytics-id="asset-delete-cancel" variant="text">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          data-analytics-id="asset-archive-confirm"
          variant="contained"
        >
          Archive
        </Button>
      </DialogActions>
    </Dialog>
  );
};
